module.exports = __webpack_public_path__ + "img/img_denglu.a2cbdfa3.png";